export default __webpack_public_path__ + "static/media/pdc_meeting.032a27cc.svg";